import { TResponseRateType } from '../../types/responseRateType';

export const getRateType = (rate: number): TResponseRateType => (rate > 0.6 ? 'high' : 'low');
